import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "ontos-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_dialog_action_row = _resolveComponent("ontos-dialog-action-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    "max-width": "420px",
    "onUpdate:modelValue": _ctx.onDialogInput
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_page_header, _mergeProps(_ctx.heading, { level: 2 }), {
                controls: _withCtx(() => [
                  _createVNode(_component_ontos_dialog_actions, {
                    onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
                  })
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }),
          (_ctx.dimensions.length > 1)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                class: "pt-0 pb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    "model-value": _ctx.dimension,
                    items: _ctx.dimensions,
                    "item-title": "name",
                    "item-value": "key",
                    label: _ctx.$tt('dimension'),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:dimension', $event)))
                  }, null, 8, ["model-value", "items", "label"])
                ]),
                _: 1
              }))
            : (_ctx.field)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 1,
                  class: "pt-0 pb-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.field), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_v_list, {
            density: "compact",
            class: "option-list"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: option.id,
                  disabled: !_ctx.multiple && _ctx.isChosen(option),
                  onClick: ($event: any) => (_ctx.onPick(option))
                }, _createSlots({
                  default: _withCtx(() => [
                    _createVNode(_component_ontos_colored_value, {
                      option: option,
                      form: _ctx.form
                    }, null, 8, ["option", "form"])
                  ]),
                  _: 2
                }, [
                  (_ctx.multiple)
                    ? {
                        name: "prepend",
                        fn: _withCtx(() => [
                          _createVNode(_component_v_checkbox_btn, {
                            "model-value": _ctx.isChosen(option),
                            density: "compact",
                            class: "flex-grow-0 mr-2",
                            "onUpdate:modelValue": ($event: any) => (_ctx.toggle(option))
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        key: "0"
                      }
                    : undefined,
                  (!_ctx.multiple && _ctx.isChosen(option))
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        key: "1"
                      }
                    : undefined
                ]), 1032, ["disabled", "onClick"]))
              }), 128))
            ]),
            _: 1
          }),
          (_ctx.multiple)
            ? (_openBlock(), _createBlock(_component_ontos_dialog_action_row, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    size: "small",
                    color: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save', _ctx.chosen)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        start: ""
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("mdi-floppy", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$tt('save')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onUpdate:modelValue"]))
}